export const FormHistoryActionTypes = {
  PUSH_CHANGE: 'zola/cards/form_history/PUSH_CHANGE',
  POP_CHANGE: 'zola/cards/form_history/POP_CHANGE',
  CLEAR_HISTORY: 'zola/cards/form_history/CLEAR_HISTORY',
  UPDATE_HISTORY_ELEMENT: 'zola/card/card_project/UPDATE_FORM_HISTORY_ELEMENT',
};

export default FormHistoryActionTypes;
